import { render } from "./JobDetailsPanel.vue?vue&type=template&id=aa678fd0&scoped=true"
import script from "./JobDetailsPanel.vue?vue&type=script&lang=js"
export * from "./JobDetailsPanel.vue?vue&type=script&lang=js"

import "./JobDetailsPanel.vue?vue&type=style&index=0&id=aa678fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa678fd0"]])

export default __exports__